module.exports = __webpack_public_path__ + "static/img/9.182344dd.jpg";